// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.boxPayButton {
  position: absolute;
  right: 0;
  float: right;
  border-radius: 5px;
  padding-left: 2px;
  padding-right: 2px;
  margin-bottom: 5px;
}

.displayBox {
  /* display: flex; */
  display: inline-block;
  position: relative;
  margin-bottom: 1rem;
  width: 100%;
}

.title-container {
  float: left;
}

.exp-button-container {
  float: right;
}

.cutomizedButton {
  width: 150px;
  padding: 10px;
  position: absolute;
  z-index: 1;
}

.InovuaReactDataGrid {
  border-radius: 16px 16px 0px 0px;
}

.InovuaReactDataGrid__header {
  border-radius: 16px 16px 0px 0px;
}

.InovuaReactDataGrid__header,
.InovuaReactDataGrid__column-header__resize-wrapper,
.InovuaReactDataGrid__column-header,
.InovuaReactDataGrid__column-header__content {
  height: 54px !important;
  width: 1116px !important;
}

.InovuaReactDataGrid__column-header__content {
  padding-left: 24px !important;
}

.InovuaReactDataGrid__column-header__content {
  font-family: "Poppins" !important;
  font-weight: 400 !important;
  font-size: 16px;
  line-height: 20px !important;
  padding-left: 48px;
  display: flex;
  align-items: center;
  margin: 0;
  border-right: 1px solid #ffffff;
}

.InovuaReactDataGrid__column-header--first .InovuaReactDataGrid__column-header__content {
  border-radius: 16px 0px 0px 0px;
}

.InovuaReactDataGrid__column-header--last .InovuaReactDataGrid__column-header__content {
  border-radius: 0px 16px 0px 0px;
  border-right: none;
}

.InovuaReactDataGrid {
  color: black;
}

.InovuaReactDataGrid__cell__content {
  padding-left: 28px;
  font-weight: 500 !important;
  font-size: 14px !important;
  /* line-height: 60px; */
  font-family: "Poppins";
  display: flex;
  align-items: center;
  /* display: inline-block; */
  /* overflow-wrap: break-word; */
  white-space: normal;
  text-align: justify;
  /* overflow-y: scroll; */
  height: calc(100% + 2%);

}

.InovuaReactDataGrid__column-header__resize-wrapper {
  border: 0 !important;
}

#boxPayGrid {
  user-select: text;
  outline: none;
  /* Remove the blue outline on selection */
}

#boxPayGrid:-webkit-any-link {
  text-decoration: none;
  /* Remove the default link underline */
}

#boxPayGrid:-webkit-autofill,
#boxPayGrid:-webkit-autofill:hover,
#boxPayGrid:-webkit-autofill:focus,
#boxPayGrid:-webkit-autofill:active {
  -webkit-box-shadow: 0 0 0 30px white inset !important;
  /* Remove the yellow autofill background */
  -webkit-text-fill-color: #000 !important;
  /* Set the autofill text color */
}

.pipe {
  border-right: 1px solid #cecece;
  padding: 1rem 0;
}

.custom-pagination {
  padding: 0.4rem 1rem;
  display: flex;
  align-items: center;
  gap: 1.5rem;
  border: 1px solid rgb(238, 238, 238);
  color: rgb(111, 111, 111);
}

.resultBox {
  display: grid;
  grid-template-columns: 1fr auto;
  align-items: center;
  gap: 1rem;
}

.page-box {
  display: flex;
  align-items: center;
  gap: 0.7rem;
}`, "",{"version":3,"sources":["webpack://./src/components/css/boxPayGrid.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,QAAQ;EACR,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;;;;EAIE,uBAAuB;EACvB,wBAAwB;AAC1B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,iCAAiC;EACjC,2BAA2B;EAC3B,eAAe;EACf,4BAA4B;EAC5B,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,2BAA2B;EAC3B,0BAA0B;EAC1B,uBAAuB;EACvB,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,+BAA+B;EAC/B,mBAAmB;EACnB,mBAAmB;EACnB,wBAAwB;EACxB,uBAAuB;;AAEzB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,yCAAyC;AAC3C;;AAEA;EACE,qBAAqB;EACrB,sCAAsC;AACxC;;AAEA;;;;EAIE,qDAAqD;EACrD,0CAA0C;EAC1C,wCAAwC;EACxC,gCAAgC;AAClC;;AAEA;EACE,+BAA+B;EAC/B,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,+BAA+B;EAC/B,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb","sourcesContent":[".boxPayButton {\n  position: absolute;\n  right: 0;\n  float: right;\n  border-radius: 5px;\n  padding-left: 2px;\n  padding-right: 2px;\n  margin-bottom: 5px;\n}\n\n.displayBox {\n  /* display: flex; */\n  display: inline-block;\n  position: relative;\n  margin-bottom: 1rem;\n  width: 100%;\n}\n\n.title-container {\n  float: left;\n}\n\n.exp-button-container {\n  float: right;\n}\n\n.cutomizedButton {\n  width: 150px;\n  padding: 10px;\n  position: absolute;\n  z-index: 1;\n}\n\n.InovuaReactDataGrid {\n  border-radius: 16px 16px 0px 0px;\n}\n\n.InovuaReactDataGrid__header {\n  border-radius: 16px 16px 0px 0px;\n}\n\n.InovuaReactDataGrid__header,\n.InovuaReactDataGrid__column-header__resize-wrapper,\n.InovuaReactDataGrid__column-header,\n.InovuaReactDataGrid__column-header__content {\n  height: 54px !important;\n  width: 1116px !important;\n}\n\n.InovuaReactDataGrid__column-header__content {\n  padding-left: 24px !important;\n}\n\n.InovuaReactDataGrid__column-header__content {\n  font-family: \"Poppins\" !important;\n  font-weight: 400 !important;\n  font-size: 16px;\n  line-height: 20px !important;\n  padding-left: 48px;\n  display: flex;\n  align-items: center;\n  margin: 0;\n  border-right: 1px solid #ffffff;\n}\n\n.InovuaReactDataGrid__column-header--first .InovuaReactDataGrid__column-header__content {\n  border-radius: 16px 0px 0px 0px;\n}\n\n.InovuaReactDataGrid__column-header--last .InovuaReactDataGrid__column-header__content {\n  border-radius: 0px 16px 0px 0px;\n  border-right: none;\n}\n\n.InovuaReactDataGrid {\n  color: black;\n}\n\n.InovuaReactDataGrid__cell__content {\n  padding-left: 28px;\n  font-weight: 500 !important;\n  font-size: 14px !important;\n  /* line-height: 60px; */\n  font-family: \"Poppins\";\n  display: flex;\n  align-items: center;\n  /* display: inline-block; */\n  /* overflow-wrap: break-word; */\n  white-space: normal;\n  text-align: justify;\n  /* overflow-y: scroll; */\n  height: calc(100% + 2%);\n\n}\n\n.InovuaReactDataGrid__column-header__resize-wrapper {\n  border: 0 !important;\n}\n\n#boxPayGrid {\n  user-select: text;\n  outline: none;\n  /* Remove the blue outline on selection */\n}\n\n#boxPayGrid:-webkit-any-link {\n  text-decoration: none;\n  /* Remove the default link underline */\n}\n\n#boxPayGrid:-webkit-autofill,\n#boxPayGrid:-webkit-autofill:hover,\n#boxPayGrid:-webkit-autofill:focus,\n#boxPayGrid:-webkit-autofill:active {\n  -webkit-box-shadow: 0 0 0 30px white inset !important;\n  /* Remove the yellow autofill background */\n  -webkit-text-fill-color: #000 !important;\n  /* Set the autofill text color */\n}\n\n.pipe {\n  border-right: 1px solid #cecece;\n  padding: 1rem 0;\n}\n\n.custom-pagination {\n  padding: 0.4rem 1rem;\n  display: flex;\n  align-items: center;\n  gap: 1.5rem;\n  border: 1px solid rgb(238, 238, 238);\n  color: rgb(111, 111, 111);\n}\n\n.resultBox {\n  display: grid;\n  grid-template-columns: 1fr auto;\n  align-items: center;\n  gap: 1rem;\n}\n\n.page-box {\n  display: flex;\n  align-items: center;\n  gap: 0.7rem;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
